/**
 * Палитра своих сфер.
 *
 * В базе хранится ключ, а не цвет: цвета в приложении заданы переменными темы
 * и в тёмной берутся светлее. Запиши мы готовый `oklch(...)` — выбранный
 * однажды оттенок остался бы тёмным на тёмном фоне.
 *
 * Все восемь достаточно тёмные для белой подписи поверх заливки — поэтому у
 * своей сферы нет вопроса «каким цветом писать по ней», в отличие от жёлтого
 * «Отдыха» среди встроенных.
 */

export const SPHERE_PALETTE = [
  { key: 'teal', label: 'Бирюзовый' },
  { key: 'blue', label: 'Синий' },
  { key: 'indigo', label: 'Индиго' },
  { key: 'plum', label: 'Сливовый' },
  { key: 'crimson', label: 'Малиновый' },
  { key: 'rust', label: 'Терракотовый' },
  { key: 'olive', label: 'Оливковый' },
  { key: 'slate', label: 'Грифельный' },
] as const;

export type SpherePaletteKey = (typeof SPHERE_PALETTE)[number]['key'];

const KEYS = new Set<string>(SPHERE_PALETTE.map((color) => color.key));

/** Ключ палитры в CSS-значение. Незнакомый ключ не роняет экран. */
export function paletteColor(key: string): string {
  return KEYS.has(key)
    ? `var(--sphere-custom-${key})`
    : `var(--sphere-custom-${SPHERE_PALETTE[0].key})`;
}

/**
 * Цвет для новой сферы: первый из неиспользованных.
 *
 * Две сферы одного цвета неразличимы на диаграмме, а выбирать вручную человека
 * заставлять незачем — он пришёл завести сферу, а не раскрашивать.
 */
export function suggestPaletteKey(used: readonly string[]): SpherePaletteKey {
  const taken = new Set(used);
  return SPHERE_PALETTE.find((color) => !taken.has(color.key))?.key ?? SPHERE_PALETTE[0].key;
}
